import { defineComponent as _defineComponent } from 'vue'
import ClientRowInfo from '@/app/components/clients/clientInfo/ClientRowInfo.vue';
import { Client, FeatureFlag } from 'ah-api-gateways';
import OpenPositionsDashboardWidget from '@/app/components/trades/widgets/OpenPositionsDashboardWidget.vue';
import WalletsDashboardWidget from 'ah-wallets/src/components/WalletsDashboardWidget.vue';
import LimitsAndCollateralDashboardWidget from 'ah-trades/src/components/limitsAndCollateral/LimitsAndCollateralDashboardWidget.vue';
import OnBehalfOf from 'ah-common-lib/src/onBehalfOf/OnBehalfOf';
import DownloadEOMStatementModal from 'ah-trades/src/components/modals/DownloadEOMStatementModal.vue';
import { shortOpenPositionsTradeTableFields } from 'ah-trades/src/models/tradeTableFields';
import { computed, ref, watch } from 'vue';
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useRouter } from 'vue-router/composables';
import CollateralStatusDashboardWidget from 'ah-trades/src/components/collaterals/CollateralStatusDashboardWidget.vue';
import { useFeatureFlag } from 'ah-common-stores/src/stores/featureFlagStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySingleClientDashboardView',
  props: { clientId: { type: String, required: true } },
  setup(__props) {

const props = __props;

const requestManager = useRequestManager().manager;

const services = getServices();

const router = useRouter();



const client = ref<Client>();

const tradesConfig = computed(() => {
  return {
    tableFields: shortOpenPositionsTradeTableFields,
  };
});

const { isActive: isVariationMarginFeatureActive, loadFlag: loadVariationMarginFeatureFlag } = useFeatureFlag({
  featureFlag: FeatureFlag.VARIATION_MARGIN_AND_LIMITS_FEATURE,
});

function onClientIdChange() {
  requestManager
    .sameOrCancelAndNew('getClient', services.client.getClient(props.clientId))
    .subscribe((response) => (client.value = response));
}

function go(to: string) {
  const baseUrl = '/admin/activity/clients';
  router.push({ path: `${baseUrl}/${props.clientId}/${to}` });
}

function goToCollateral() {
  loadVariationMarginFeatureFlag().then(() => {
    go(isVariationMarginFeatureActive.value ? 'limits-collateral' : 'collateral-management');
  });
}

watch(() => props.clientId, onClientIdChange, { immediate: true });

return { __sfc: true,requestManager, services, router, props, client, tradesConfig, isVariationMarginFeatureActive, loadVariationMarginFeatureFlag, onClientIdChange, go, goToCollateral, ClientRowInfo, OpenPositionsDashboardWidget, WalletsDashboardWidget, LimitsAndCollateralDashboardWidget, OnBehalfOf, DownloadEOMStatementModal, CollateralStatusDashboardWidget }
}

})